import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'engine',
      label: i18n.t('irrigation.engine'),
      minWidth: 150,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 150,
    },
    {
      prop: 'design',
      label: i18n.t('irrigation.design'),
      minWidth: 150,
    },
    {
      prop: 'brand',
      label: i18n.t('devices.brand'),
      minWidth: 150,
    },
    {
      prop: 'model',
      label: i18n.t('irrigation.model'),
      minWidth: 150,
    },
    {
      prop: 'energy_source',
      label: i18n.t('irrigation.energy_source'),
      minWidth: 150,
    },
    {
      prop: 'nozzle',
      label: i18n.t('irrigation.nozzle'),
      minWidth: 150,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
    },
    {
      prop: 'aspersion_ha',
      label: i18n.t('irrigation.sprinkling'),
      minWidth: 150,
    },
    {
      prop: 'efficiency',
      label: i18n.t('irrigation.efficiency'),
      minWidth: 150,
    },
    {
      prop: 'lamina',
      label: i18n.t('irrigation.plate'),
      minWidth: 150,
    },
    {
      prop: 'psi_real',
      label: i18n.t('irrigation.real_psi'),
      minWidth: 150,
    },
    {
      prop: 'irrigation_area',
      label: i18n.t('irrigation.irrigation_area_ha'),
      minWidth: 150,
    },
    {
      prop: 'irrigation_blocks',
      label: i18n.t('irrigation.irrigation_blocks_number'),
      minWidth: 150,
    },
    {
      prop: 'hourmeter',
      label: i18n.t('irrigation.hourmeter'),
      minWidth: 150,
    },
    {
      prop: 'hydrometer',
      label: i18n.t('irrigation.hydrometer'),
      minWidth: 150,
    },
  ];

  return { Table };
};

export default configTable;


